import React from "react";
import { Select } from "antd/lib";
import { Option } from "antd/lib/mentions";

export const MobileDropdown = ({ onGoingProjects, setActiveProject }) => {
  const handleChange = (value) => {
    setActiveProject(value);
  };

  return (
    <Select
      onChange={handleChange}
      defaultValue={onGoingProjects[0]?.title}
      placeholder={onGoingProjects[0]?.title}
    >
      {onGoingProjects.map((_proj) => (
        <Option value={_proj._id}>{_proj.title}</Option>
      ))}
    </Select>
  );
};
